export default "https://assets.egbcdn.net/assets/packs/_/images/svg_icons/app-shop-caf34df6c4ae932dc705a6ec3d812b4c.svg";